import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';

import { Sidebar, Topbar } from './components';



const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
}));

const Main = props => {
  // Para exibir o menu só após confirmação do perfil
  const [openMenu, showMenu] = useState(false);
  let interval = setInterval(function() {
    if (localStorage.getItem('planos_y') !== null) {
      showMenu(true);
      clearInterval(interval);
    }
  }, 100);



  const { children, history } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(true);// true ou false para iniciar o menu aberto ou fechado

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  let shouldOpenSidebar = openSidebar;

  let marginContent = isDesktop;

  if (isDesktop) {
    if (openSidebar) {
      marginContent = true;
    }
    else {
      marginContent = false;
    }
  }
  

  return (
    <div
      id="layoutMain"
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: marginContent
      })}
    >
      <Topbar
        onSidebarOpen={handleSidebarOpen}
        openSidebar={shouldOpenSidebar}
        onSidebarClose={handleSidebarClose}
        history={history}
      />
      {
        openMenu === true ? (
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
        history={history}
      />
        ) : ('')
      }

      <main className={classes.content}>
        {children}
      </main>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  history: PropTypes.object
};

export default Main;
